import { memo } from 'react';
import MaximizeChatSpace from './MaximizeChatSpace';
import FontSizeSelector from './FontSizeSelector';
import SendMessageKeyEnter from './EnterToSend';
import ShowCodeSwitch from './ShowCodeSwitch';
import { ForkSettings } from './ForkSettings';
import ChatDirection from './ChatDirection';
import LaTeXParsing from './LaTeXParsing';
import ModularChat from './ModularChat';
import SaveDraft from './SaveDraft';

function Chat() {
  return (
    <div className="text-text-primary flex flex-col gap-3 p-1 text-sm">
      <div className="bordered-item">
        <FontSizeSelector />
      </div>
      <div className="bordered-item">
        <ChatDirection />
      </div>
      <div className="bordered-item">
        <SendMessageKeyEnter />
      </div>
      <div className="bordered-item">
        <ShowCodeSwitch />
      </div>
      <div className="bordered-item">
        <SaveDraft />
      </div>
      <ForkSettings />
      <div className="bordered-item">
        <ModularChat />
      </div>
      <div className="bordered-item">
        <LaTeXParsing />
      </div>
    </div>
  );
}

export default memo(Chat);
